const ENABLED = 'enabled'

interface HUBPageProps {
  shouldShowRewards: boolean
  shouldShowClubCard: boolean
  shouldShowPayments: boolean
  shouldShowNewsWidget: boolean
  shouldShowMemberBanner: boolean
  shouldShowPendingMemberNotice: boolean
}

interface SettingsProps {
  shouldShowCommunitySettings: boolean
  shouldShowAlternativeId: boolean
  shouldShowPayment: boolean
  shouldShowAddress: boolean
  shouldShowNewsletter: boolean
  shouldShowDigitalReceipt: boolean
  shouldShowPrivacy: boolean
}

interface AllPurchasePageProps {
  shouldShowStoreReceipts: boolean
  shouldShowReceiptButton: boolean
  shouldShowMyInvoicesKlarna: boolean
  shouldShowTrackOrderButton: boolean
  shouldShowRewear: boolean
  shouldShowEstimatedDelivery: boolean
}

interface AccountFeatureReturnProps {
  account: boolean
  pages: {
    hub: HUBPageProps
    settings: SettingsProps
    allPurchase: AllPurchasePageProps
  }
  shouldShowFooter: boolean
}

const getSettingsPageToggles = (): SettingsProps => ({
  shouldShowCommunitySettings:
    process.env.IS_ACCOUNT_SETTINGS_COMMUNITY_SETTINGS_ENABLED === ENABLED,
  shouldShowAlternativeId: process.env.IS_ACCOUNT_SETTING_ALTERNATIVE_ID_ENABLED === ENABLED,
  shouldShowAddress: process.env.IS_ACCOUNT_SETTING_ADDRESS_ENABLED === ENABLED,
  shouldShowPayment: process.env.IS_ACCOUNT_SETTING_PAYMENTS_ENABLED === ENABLED,
  shouldShowNewsletter: process.env.IS_ACCOUNT_SETTING_NEWSLETTER_ENABLED === ENABLED,
  shouldShowDigitalReceipt: process.env.IS_ACCOUNT_SETTING_DIGITAL_RECEIPT_ENABLED === ENABLED,
  shouldShowPrivacy: process.env.IS_ACCOUNT_SETTING_PRIVACY_ENABLED === ENABLED,
})

const getHubPageToggles = (): HUBPageProps => ({
  shouldShowRewards: process.env.IS_ACCOUNT_REWARDS_ENABLED === ENABLED,
  shouldShowClubCard: process.env.IS_ACCOUNT_CLUB_POINTS_ENABLED === ENABLED,
  shouldShowPayments: process.env.IS_ACCOUNT_PAYMENTS_ENABLED === ENABLED,
  shouldShowNewsWidget: process.env.IS_ACCOUNT_NEWS_WIDGET_ENABLED === ENABLED,
  shouldShowMemberBanner: process.env.IS_ACCOUNT_MEMBER_BANNER_ENABLED === ENABLED,
  shouldShowPendingMemberNotice: process.env.IS_ACCOUNT_MEMBER_NOTICE_ENABLED === ENABLED,
})

const getAllPurchasePageToggles = (): AllPurchasePageProps => ({
  shouldShowStoreReceipts: process.env.IS_ACCOUNT_STORE_RECEIPT_ENABLED === ENABLED,
  shouldShowReceiptButton: process.env.IS_ACCOUNT_RECEIPT_BUTTON_ENABLED === ENABLED,
  shouldShowMyInvoicesKlarna: process.env.IS_ACCOUNT_MY_INVOICES_KLARNA_ENABLED === ENABLED,
  shouldShowTrackOrderButton: process.env.IS_ACCOUNT_MY_ORDER_TRACKING_ENABLED === ENABLED,
  shouldShowRewear: process.env.IS_ACCOUNT_REWEAR_ENABLED === ENABLED,
  shouldShowEstimatedDelivery: process.env.IS_ACCOUNT_ESTIMATED_DELIVERY_ENABLED === ENABLED,
})

const useAccountFeature = (): AccountFeatureReturnProps => {
  const account = process.env.IS_REACT_ACCOUNT_ENABLED === ENABLED
  const hub = getHubPageToggles()
  const settings = getSettingsPageToggles()
  const allPurchase = getAllPurchasePageToggles()

  const shouldShowFooter = process.env.IS_REACT_FOOTER_ENABLED === ENABLED

  return {
    account,
    pages: {
      hub,
      settings,
      allPurchase,
    },
    shouldShowFooter,
  }
}

export default useAccountFeature
